import Auth from "./Auth";
import { all } from "redux-saga/effects";

//Admin Sagas
import User from "./User";
import Role from "./Role";
import Module from "./Module";
import RoleModule from "./RoleModule";

//App Sagas
import Client from "./Client";
import Records from './InitFormSaga';
import Company from "./CompanySaga";



export default function* rootSaga(getState) {
  yield all([
    Auth(),
    // App Sagas
    Client(),
    Company(),
    Records(),

    // Admin Sagas
    User(),
    Role(),
    Module(),
    RoleModule(),
    
  ]);
}
